<div class="business-app-component">
  <mat-card appearance="outlined">
    <mat-tab-group [mat-stretch-tabs]="false" mat-align-tabs="start">
      <mat-tab label="APPLICANT"><div *ngTemplateOutlet="applicantTab;"></div></mat-tab>
      <mat-tab label={{getOrganisationTypeForTitle(application)}}><div *ngTemplateOutlet="directorsTab"></div></mat-tab>
      <mat-tab label="GUARANTORS"><div *ngTemplateOutlet="guarantorTab"></div></mat-tab>
      <mat-tab label="QUOTE"><div *ngTemplateOutlet="quoteTab"></div></mat-tab>
      <mat-tab label="REFERENCE"><div *ngTemplateOutlet="referenceTab"></div></mat-tab>
      @if (isInternalUser()) {
      <mat-tab label="PPSR SEARCH"><div *ngTemplateOutlet="PPSRSearchTab"></div></mat-tab>
      }
    </mat-tab-group>
  </mat-card>
</div>

<ng-template #applicantTab>
  <div class="row separator header"
    fxLayout="row"
    fxLayoutGap="10px"
    fxLayoutAlign="space-between center"
    fxLayout.lt-md="column"
    fxLayoutAlign.lt-md="center start">
    @if (applicationStatus && applicationStatus==='Under Review') {
      <div class="col-md-3 under-review">
        <status-box type="under-review"></status-box>
      </div>
    } @else {
      <div></div>
    }
    <div fxLayout="row"
      fxLayoutGap="10px"
      fxLayoutAlign="start center"
      fxLayout.lt-md="column"
      fxLayoutAlign.lt-md="center start">
      @if (applicationStatus !== 'Closed' && application.AppInfoSalesforceID) {
        <button mat-flat-button class="inactive ml-2 w-lt-md-100" (click)="onWithdrawApplication()">
          <span class="mdi mdi-arrow-u-left-bottom" matPrefix></span>
          Withdraw Application
        </button>
      }  
      @if (applicationStatus !== 'Closed' && 
          application.AppInfoStageName !== 'Draft' && 
          !application.AppInfoSalesforceID &&
          (user?.AccessLevel ?? '') === 'admin' && 
          !application.SystemCreditStatus
      ) {
        <button mat-flat-button class="inactive ml-2 w-lt-md-100" (click)="sendToDraft()">
          <span class="mdi mdi-arrow-u-left-bottom" matPrefix></span>
          Back To Draft
        </button>
      }
    </div>
  </div>
  <div class="section">
    <div class="row">
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Application ID</div>
          <div body>{{getBrokerApplicationId(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Salesforce ID</div>
          <div body>{{getAppSalesforceId(application)}}</div>
        </cell>
      </div>

    </div>



    <div class="row reduced-row">
      <div class="col-lg-6 col-md-12">
        <cell>
          <div label>Introducer</div>
          <div body>
            <searchable-select 
              [formControl]="brokerControl"
              [items]="brokerCompanies"
              [multi]="false"
              (selectionChange)="onBrokerChange($event)"
              [isEditable]="isAdminUser() && isApplicationStage()"
            />
          </div>
        </cell>
      </div>
      
      <div class="col-lg-6 col-md-12">
        <cell>
          <div label>Contact</div>
          <div body>
            <searchable-select 
              [formControl]="submitterControl"
              [items]="submitterUsers"
              [multi]="false"
              (selectionChange)="onSubmitterChange($event)"
              [isEditable]="isAdminOrSalesUser()"
            />
          </div>
        </cell>
      </div>
    </div>

        <div class="row reduced-row-gap">
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>Sales Contact</div>
              <div body>
                <searchable-select
                  [formControl]="salesContactControl"
                  [items]="salesContactUsers"
                  [multi]="false"
                  (selectionChange)="onSalesContactChange($event)"
                  [isEditable]="isAdminUser()">
                </searchable-select>
              </div>
            </cell>
          </div>
        
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>Credit Officer</div>
              <div body>
                <searchable-select 
                  [formControl]="creditOfficerControl"
                  [items]="creditOfficerUsers"
                  [multi]="false"
                  (selectionChange)="onCreditOfficerChange($event)"
                  [isEditable]="isAdminOrCredit()"
                />
              </div>
            </cell>
          </div>
        </div>

        <div class="row reduced-row-gap">
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>Settlement Officer</div>
              <div body>
                <searchable-select 
                  [formControl]="settlementControl"
                  [items]="settlementUsers"
                  [multi]="false"
                  (selectionChange)="onSettlementOfficerChange($event)"
                  [isEditable]="isAdminOrOperationUser()"
                />
              </div>
            </cell>
          </div>
          <div class="col-lg-6 col-md-12">
            <cell>
              <div label>AML Officer</div>
              <div body>
                <searchable-select
                  [formControl]="amlOfficerControl"
                  [items]="amlOfficerUsers"
                  [multi]="false"
                  (selectionChange)="onAmlOfficerChange($event)"
                  [isEditable]="canEditAmlOfficer"
                />
              </div>
            </cell>
          </div>
          @if (application.AdditionalBrokerCorrespondent && AdditionalBrokerCorrespondentUserId) {
              <div class="col-lg-6 col-md-12">
                <cell>
                  <div label>Additional Correspondant Contact</div>
                  <div body>
                    <searchable-select 
                      [formControl]="additionalCorrespondentControl"
                      [items]="additionalCorrespondentUsers"
                      [multi]="false"
                      (selectionChange)="onAdditionalCorrespondentChange($event)"
                      [isEditable]="isAdminUser()"
                    />
                  </div>
                </cell>
              </div>
            }
          </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>

  <div class="row">
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Interest rate</div>
          <div body>{{getInterestRate(application) | number : '1.0-2'}}<span class="mdi mdi-percent"></span></div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Amount financed (incl Brokerage)</div>
          <div body><span class="mdi mdi-currency-usd"></span>{{paymentChartData.principalAmt + paymentChartData.brokerageAmount | looseCurrency:'':''}}</div>
        </cell>
      </div>
      @if (getBrokerFlowId(application)) {
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>BrokerFlow ID </div>
            <div body>{{getBrokerFlowId(application)}}</div>
          </cell>
        </div>
      }
    </div>
  
  <mat-divider [inset]="true"></mat-divider>

  <div class="section">
    <div class="row">
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>ABN Age</div>
          <div body>{{getAbnAge(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>ABN Age (with continuity)</div>
          <div body>{{getAbnAgeWithContinuity(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>GST Age</div>
          <div body>{{getGstAge(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>GST Age (with continuity)</div>
          <div body>{{getGstAgeWithContinuity(application)}}</div>
        </cell>
      </div>
    </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>

  <div class="section">
    <div class="row">
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Company name</div>
          <div body>{{getCompanyName(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Organisation type</div>
          <div body>{{getOrganisationType(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Repayment Type</div>
          <div body>{{getRepaymentType(application)}}</div>
        </cell>
      </div>
    </div>
    <mat-divider [inset]="true"></mat-divider>
    <div class="row">
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>ABN</div>
          <div body>{{getAbn(application)}}</div>
        </cell>
      </div>
      @if (getOrganisationType(application)==='Company') {
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>ACN</div>
            <div body>{{getAcn(application)}}</div>
          </cell>
        </div>
      }
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <cell>
          <div label class="borrower-entity-guarantor-label">
            Borrowing Entity to Appear as Guarantor
            <span
              matTooltip="Required when property is owned by the borrowing entity"
              matTooltipPosition="after"
              class="tooltip-icon mdi mdi-help-circle-outline ml-1"></span>
          </div>
          <div body class="borrower-property-owner-body">
            <span>{{ application.isBorrowerPropertyOwner ? 'Yes' : 'No' }}</span>
            @if (canEditBorrowerEntityPropertyOwner()) {
              <button mat-icon-button (click)="onEditBorrowerEntityPropertyOwner()" matTooltip="Edit additional guarantor setting">
                <span class="mdi mdi-pencil-outline"></span>
              </button>
            }
          </div>
        </cell>
      </div>
    </div>
    <mat-divider [inset]="true"></mat-divider>
    @if (getPreviousBusiness(application)) {
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <cell>
            <div label>Previous Business</div>
            <div body>{{getPreviousBusinessName(application)}}</div>
          </cell>
        </div>
        @if (getPreviousBusinessABN(application)) {
          <div class="col-lg-3 col-md-12">
            <cell>
              <div label>Previous Business ABN</div>
              <div body>{{getPreviousBusinessABN(application)}}</div>
            </cell>
          </div>
        }
        @if (getPreviousBusinessACN(application)) {
          <div class="col-lg-3 col-md-12">
            <cell>
              <div label>Previous Business ACN</div>
              <div body>{{getPreviousBusinessACN(application)}}</div>
            </cell>
          </div>
        }
      </div>
      <mat-divider [inset]="true"></mat-divider>
    }
  </div>

  <div class="section">
    <div class="row">
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label> Equifax Director Score above 700</div>
          <div body>{{getEquifaxScoreAboveThreshold(application)}}</div>
        </cell>
      </div>
    </div>
    <mat-divider [inset]="true"></mat-divider>
    <loan-purpose-summary [loanPurpose]="application.AppInfo.LoanPurpose"></loan-purpose-summary>
    <mat-divider [inset]="true"></mat-divider>
    <div class="row">
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Adverse on file</div>
          <div body>{{getAdverseOnFile(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Property owner</div>
          <div body>{{getPropertyOwner(application)}}</div>
        </cell>
      </div>
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Doc Fee financed</div>
          <div body>{{getDocFeeFinanced(application)}}</div>
        </cell>
      </div>
    </div>
    <mat-divider [inset]="true"></mat-divider>
    <div class="row">
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>Brokerage</div>
          <div body><span class="mdi mdi-currency-usd"></span>
        {{getBrokerageAmount(application) ? getBrokerageAmount(application) : getBrokerage(application) * getLoanAmount(application) / 100 | looseCurrency:'':''}}</div>
      </cell>
    </div>
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Repayment frequency</div>
        <div body>{{getRepaymentFrequency(application)}}</div>
      </cell>
    </div>
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Payment Type</div>
        <div body>{{getPaymentType(application)}}</div>
      </cell>
    </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>
  <div class="row">
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Loan amount</div>
        <div body>{{getLoanAmount(application) | looseCurrency}}</div>
      </cell>
    </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>
</div>


<div class="section">
  <div class="row">
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Revenue</div>
        <div body><span class="mdi mdi-currency-usd"></span>{{getRevenue(application) | looseCurrency:'':''}}</div>
      </cell>
    </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>
  <div class="row anzsic-row">
    <div class="col-lg-6 col-md-12">
      <cell>
        <div label>Primary industry</div>
        <div body>{{getApplicationPrimaryIndustry(application)}}</div>
      </cell>
    </div>
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Industry sector</div>
        <div body>{{getIndustrySector(application)}}</div>
      </cell>
    </div>
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Industry class</div>
        <div body>{{getSubdivisionSector(application)}}</div>
      </cell>
    </div>
    @if (canEditAnzsic()) {
      <button mat-icon-button class="edit-anzsic-btn" (click)="onEditAnzsic()" matTooltip="Edit ANZSIC Code">
        <span class="mdi mdi-pencil-outline"></span>
      </button>
    }
  </div>
  <mat-divider [inset]="true"></mat-divider>
  <div class="row">
    <div class="col-lg-6 col-md-12">
      <cell>
        <div label>Principal place of business address</div>
        <div body>{{getPrimaryBusinessAddress(application)}}</div>
      </cell>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6 col-md-12">
      <cell>
        <div label>Registered business address</div>
        <div body>{{getRegisteredBusinessAddress(application)}}</div>
      </cell>
    </div>
  </div>
  <mat-divider [inset]="true"></mat-divider>
</div>

@if (getApplicationNotes(application)) {
  <div class="section">
    <div class="row">
      <div class="col-12">
        <div class="mat-h2">Application notes</div>
      </div>
    </div>
    <div class="row">
      <div class="co-12l">
        <cell>
          <div body>{{getApplicationNotes(application)}}</div>
        </cell>
      </div>
    </div>
  </div>
}
<mat-divider [inset]="true"></mat-divider>
</ng-template>

<ng-template #directorsTab>
  <individual-details type="all-non-guarantors" [applicationId]="application.ApplicationId"></individual-details>
</ng-template>

<ng-template #guarantorTab>
  <individual-details type="guarantors-only" [applicationId]="application.ApplicationId"></individual-details>
</ng-template>

<ng-template #quoteTab>

  <business-quote [application]="application"
    [isBusinessLoans]="true"
    [amortizationScheduleData]="amortizationScheduleData"
    [repaymentEstimationData]="repaymentEstimationData"
    [paymentChartData]="paymentChartData"
    [amortizationChartData]="amortizationChartData"
    [calculationLog]="calculationLog">
  </business-quote>
</ng-template>

<ng-template #referenceTab>
  <references-details [application]="application"></references-details>
</ng-template>

<ng-template #PPSRSearchTab>
  <div class="row ml-2">
    <div class="col-12">
      <div class="mat-h3">PPSR search</div>
    </div>
  </div>

  <div class="row ml-2">
    <div class="col-lg-3 col-md-12">
      <cell>
        <div label>Company name</div>
        <div body>{{getCompanyName(application)}}</div>
      </cell>
    </div>
    @if (getAbn(application)) {
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>ABN</div>
          <div body>{{getAbn(application)}}</div>
        </cell>
      </div>
    }
    @if (getAcn(application)) {
      <div class="col-lg-3 col-md-12">
        <cell>
          <div label>ACN</div>
          <div body>{{getAcn(application)}}</div>
        </cell>
      </div>
    }
    <div class="col-lg-3 col-md-12 mt-3">
      @if (!getAcn(application)) {
        <button mat-flat-button (click)="getSearchGrantors('ABN')">
          <span class="mdi mdi-magnify"></span> PPSR Search
        </button>
      }

      @if (getAcn(application)) {
        <button mat-flat-button (click)="getSearchGrantors('ACN')">
          <span class="mdi mdi-magnify"></span> PPSR Search
        </button>
      }
    </div>
  </div>

  @if (data) {
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <div class="mat-h4-custom">PPSR search result</div>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <cell>
            <div label>Account</div>
            <div body>{{grantorDetails && grantorDetails.Account ? grantorDetails.Account : 0}}</div>
          </cell>
        </div>
        <div class="col-lg-6 col-md-12">
          <cell>
            <div label>All pap no except</div>
            <div body>{{grantorDetails && grantorDetails.AllPapNoExceptCount ? grantorDetails.AllPapNoExceptCount : '--'}}</div>
          </cell>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <mat-divider [inset]="true"></mat-divider>
        </div>
        <div class="col-lg-6 col-md-12">
          <mat-divider [inset]="true"></mat-divider>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <cell>
            <div label>Motor vehicle</div>
            <div body>{{grantorDetails && grantorDetails.MotorVehicleCount ? grantorDetails.MotorVehicleCount : '--'}}</div>
          </cell>
        </div>
        <div class="col-lg-6 col-md-12">
          <cell>
            <div label>Other goods</div>
            <div body>{{grantorDetails && grantorDetails.OtherGoodsCount ? grantorDetails.OtherGoodsCount : '--'}}</div>
          </cell>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <mat-divider [inset]="true"></mat-divider>
        </div>
        <div class="col-lg-6 col-md-12">
          <mat-divider [inset]="true"></mat-divider>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <cell>
            <div label>Total</div>
            <div body>{{grantorDetails && grantorDetails.Total ? grantorDetails.Total : '--'}}</div>
          </cell>
        </div>
      </div>
    </div>
  }
</ng-template>
